import React from 'react';
import { withRouter, RouteComponentProps, useHistory } from 'react-router-dom';
import { ErrorPage } from '@guildeducationinc/recess';
import { logDataDogError } from '@src/utilities/datadog';

const PageNotFound: React.FC<RouteComponentProps> = () => {
	const history = useHistory();
	logDataDogError(new Error('Page not found'), 'PageNotFoundError', {
		url: window.location.href,
	});

	return <ErrorPage goBack={history.goBack} message={null} />;
};

export const PageNotFoundContainer = withRouter(PageNotFound);
